import { SVGProps } from 'react';

const GitPullRequestArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 0v12m14-6a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 0V8a2 2 0 0 0-2-2h-5m3-3-3 3 3 3"
    />
  </svg>
);
export default GitPullRequestArrow;
